import { ThemeProvider } from "@material-ui/core";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { theme } from "./styles/configTheme";

function App() {
  const basePath = "/saldo";

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router>
          <Switch>
            <Route exact path={basePath} component={Home} />
          </Switch>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
